// API endpoints for Required Documents operations

export const getRequiredDocumentsUrl = (businessKey: string): string => {
  return `/documents/required/${businessKey}`;
};

